export default __webpack_public_path__ + "static/media/5.d7e25cd0.webp";